import { render, staticRenderFns } from "./b7.vue?vue&type=template&id=b370ebd4&scoped=true"
import script from "./b7.vue?vue&type=script&lang=js"
export * from "./b7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b370ebd4",
  null
  
)

export default component.exports